export const SET_ACTIVE_MENU_INDEX = 'SET_ACTIVE_MENU_INDEX'
export const SET_USER_ACTIVE_MENU_INDEX = 'SET_USER_ACTIVE_MENU_INDEX'
export const SET_MESSAGE_NUMBER = 'SET_MESSAGE_NUMBER'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js